import { metrics } from '@opentelemetry/api'

import { INSTRUMENTATION_NAME } from '../constants'

export const trackBundleSize = () => {
    const meter = metrics.getMeter(INSTRUMENTATION_NAME)

    const bundleSize = meter.createObservableGauge('app.bundle_size', {
        description:
            'Decompressed (uncompressed) size of resources loaded during initial page load (excludes lazy-loaded route chunks), by type. Consistent across cached and uncached loads.',
        unit: 'By',
    })

    const measureBundleSize = () => {
        const resources = performance.getEntriesByType('resource')

        const trackedTypes = new Set(['script', 'css', 'link', 'img'])
        const decodedSizeByType = new Map<string, number>()

        for (const resource of resources) {
            if (!trackedTypes.has(resource.initiatorType)) continue

            decodedSizeByType.set(resource.initiatorType, (decodedSizeByType.get(resource.initiatorType) ?? 0) + resource.decodedBodySize)
        }

        bundleSize.addCallback(result => {
            for (const [type, size] of decodedSizeByType) {
                result.observe(size, { 'resource.type': type })
            }
        })
    }

    // Measure bundle size on initial load, ensuring we capture all resources.
    // If the page is already loaded, measure immediately; otherwise, wait for the load event.
    if (document.readyState === 'complete') {
        measureBundleSize()
    } else {
        window.addEventListener('load', measureBundleSize, { once: true })
    }
}
